
import {Component, Vue} from "vue-property-decorator";
import AccountsTable from "@/modules/Profile/components/accounts/AccountsTable.vue";
import {IAppState} from "@/interfaces/app-state.interface";

@Component({
  components: {
    AccountsTable
  }
})
export default class AccountsTab extends Vue {
  get storeState(): IAppState { return this.$store.state; }
  get corp() {
    return {
      id: this.storeState.auth.userAccess.corpId,
      name: this.storeState.auth.userAccess.corpName,
    };
  }

}
